import { IconButton, InputAdornment, TextField } from "@mui/material";
import React, { useCallback } from "react";
import SearchIcon from "@mui/icons-material/Search";
import styles from "./search.module.css";
import { debounce } from "../../../utils/debounce";

const SearchField = ({ setFilters, setSearchTerm, searchTerm, labelText }) => {
  const handleSearchChange = useCallback(
    debounce((name, value) => {
      setFilters((prev) => ({ ...prev, pageNo: 0, [name]: value }));
      // onSearch(value);
    }, 2000),
    []
  );

  const handleInputChange = (name, event) => {
    const value = event.target.value;
    setSearchTerm(value);
    handleSearchChange(name, value);
  };

  return (
    <TextField
      label={labelText || "Search"}
      color="grey"
      size="medium"
      placeholder={labelText || "Search"}
      className={styles.tableSearchField}
      value={searchTerm}
      onChange={(newValue) => handleInputChange("search", newValue)}
      // margin="dense"
      focused
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchField;
